export default __webpack_public_path__ + "static/media/info-circle-orang.9e2af5c1.svg";